import { customElement, property } from "lit/decorators.js";
import { MenuItem } from "../menu-item";

@customElement("eko-action")
class Action extends MenuItem {
  @property({ reflect: true }) role = "listitem";
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-action": Action;
  }
}

export default Action;
